export const PROGRESS_ROSTER_IMPORT = "PROGRESS_ROSTER_IMPORT";
export const PROGRESS_ROSTER_IMPORT_ERROR = "PROGRESS_ROSTER_IMPORT_ERROR";
export const PROGRESS_ROSTER_IMPORT_SUCCESS = "PROGRESS_ROSTER_IMPORT_SUCCESS";
export const CANCEL_ROSTER_IMPORT = "CANCEL_ROSTER_IMPORT";
export const CANCEL_ROSTER_IMPORT_SUCCESS = "CANCEL_ROSTER_IMPORT_SUCCESS";
export const CANCEL_ROSTER_IMPORT_ERROR = "CANCEL_ROSTER_IMPORT_ERROR";

/**
 * Track roster import job progress.
 * @param {string|number} id - Job ID.
 * @param {boolean} [loading=true] - Loading flag.
 */
export const progressRosterImport = (id, loading = true) => ({
  type: PROGRESS_ROSTER_IMPORT,
  payload: { id, loading },
});

/**
 * Success action for roster import progress.
 * @param {Object} data - Response data.
 */
export const progressRosterImportSuccess = (data) => ({
  type: PROGRESS_ROSTER_IMPORT_SUCCESS,
  payload: data,
});

/**
 * Error action for roster import progress.
 * @param {Error|Object|string} error - Error information.
 */
export const progressRosterImportError = (error) => ({
  type: PROGRESS_ROSTER_IMPORT_ERROR,
  payload: error,
});

/**
 * Cancel a running roster import by jobId.
 * @param {string} jobId - Roster import job ID.
 * @param {Object} history - React Router history to navigate after cancel.
 */
export const cancelRosterImport = (jobId, history) => ({
  type: CANCEL_ROSTER_IMPORT,
  payload: { jobId, history },
});

export const cancelRosterImportSuccess = (data) => ({
  type: CANCEL_ROSTER_IMPORT_SUCCESS,
  payload: data,
});

export const cancelRosterImportError = (error) => ({
  type: CANCEL_ROSTER_IMPORT_ERROR,
  payload: error,
});
